import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'GuideDialog',
  props: {
    showDialog: {
      type: Boolean
    },
    url: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      dialogVisible: this.showDialog
    };
  },
  created: function created() {
    this.$bus.$on('closeGuideDialog', this.handleClose);
  },
  destroyed: function destroyed() {
    this.$bus.$off('closeGuideDialog');
  },
  methods: {
    handleClose: function handleClose() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$emit('update:showDialog', false);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};